
export default {
  props: {
    playerSquad: {
      type: Object,
      default: () => ({}),
    },
    teamName: {
      type: String,
      default: ``,
    },
  },
  computed: {
    flag () {
      return this.playerSquad?.player?.country?.images?.length ? this.playerSquad.player.country.images[0] : null;
    },
    country () {
      return this.playerSquad?.player?.country?.name;
    },
    position () {
      return this.playerSquad.position !== `Unknown` ? this.playerSquad.position : null;
    },
    fullName () {
      return `${this.playerSquad.player.firstName} ${this.playerSquad.player.lastName}`;
    },
    knownAs () {
      return this.getKnownAs(this.playerSquad.player);
    },
    playerUrl () {
      return `player/${this.slugify(this.fullName)}?ref=${this.playerSquad.playerId}`;
    },
    number () {
      return this.playerSquad.squadNumber;
    },
    isLoanedIn () {
      return this.playerSquad.onLoanFrom;
    },
    isLoanedOut () {
      return this.playerSquad.onLoanTo;
    },
    isCaptain () {
      return this.playerSquad.captain;
    },
  },
};
